export class Config {
  private static get _env(): 'dev' | 'preprod' | 'prod' {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'dev';
    if (host.includes('preprod')) return 'preprod';
    return 'prod';
  }

  static serverUrl = '/api/app/';

  static tosUrl = '/api/';

  static get piwikContainer(): string | null {
    switch (Config._env) {
      case 'preprod': return '39d46792-02d8-40a8-a40e-202ff1b7df70';
      case 'prod':    return '627d5047-1897-4009-8606-01052660c027';
      default:        return null;
    }
  }

  static clusterImage: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
  static markerImage = 'assets/icons/poi/poi_';
  static mapCenter: google.maps.LatLngLiteral = {
    lat: 49.15972,
    lng: 2.143605,
  };
  static defaultMapZoom: number = 25;

  static iconSubCat = {
    '0': 'archeology',
    '1': 'culture',
    '19': 'castle',
    '3': 'architecture',
    '37': 'activities',
    '34': 'games',
    '14': 'lodging',
    '15': 'restaurant',
    '35': 'shop',
    '36': 'info',
    '12': 'event',
    '2': 'nature',
    '18': 'industrial',
    '4': 'agricultural',
    '5': 'water',
    '6': 'religious',
    '38': 'producteur',
  };

  static categories = {
    heritage: { id: 0, name: 'Heritages' },
    circuit: { id: 1, name: 'Circuits' },
    services: { id: 2, name: 'Services' },
    event: { id: 3, name: 'Events' },
    games: { id: 4, name: 'Games' },
  };

  static subCategories = {
    activities: { id: 37, name: 'Activities' },
    lodging: { id: 14, name: 'Lodging' },
    restaurants: { id: 15, name: 'Restaurants' },
    shopping: { id: 35, name: 'Shops' },
    touristInfo: { id: 36, name: 'touristInfo' },
    productLocaux: { id: 38, name: 'productLocaux' },
    outing: { id: 2, name: 'Outing' },
  };

  static circuit = [
    { id: 1, name: 'Walk' },
    { id: 2, name: 'MountainBike' },
    { id: 4, name: 'HybridBike' },
    { id: 8, name: 'Bike' },
    { id: 16, name: 'Horse' },
    { id: 32, name: 'Trail' },
    // { id: 64, name: 'Cdesi' },  // Causes broken behaviour in header nav menu
  ];

  static heritageSubCategories = [
    { id: '0', name: 'Archéologie' },
    { id: '1', name: 'Arts et culture' },
    { id: '2', name: 'Nature' },
    { id: '3', name: 'Architectures publiques' },
    { id: '4', name: 'Patrimoine agricole' },
    { id: '5', name: "Autour de l'eau" },
    { id: '6', name: 'Patrimoine religieux et commémoratif' },
    { id: '18', name: 'Patrimoine industriel et commercial' },
    { id: '19', name: 'Demeures et châteaux' },
    { id: '-1', name: 'Insolite' },
  ];

  static facebookAppId = '645205792278855';

  static imageCategories = {
    Heritages: 'assets/images/home_img_patrimoine.jpg',
    Circuits: 'assets/images/home_img_circuits.jpg',
    Services: 'assets/images/home_img_services.jpg',
    Events: 'assets/images/home_img_agenda.jpg',
  };

  static maxDist = 75;
  static maxDur = 15.0;

  static hotspots = [
    {
      name: 'perche1',
      position: { lat: 49.07166780000001, lng: 2.1664232000000005 },
      label: "Château d'Auvers",
      deg: 160,
    },
    {
      name: 'perche2',
      position: { lat: 49.1535543, lng: 2.072103 },
      label: 'Theuville',
      deg: 215,
    },
    {
      name: 'perche3',
      position: { lat: 49.103154, lng: 1.8350722000000002 },
      label: 'Wy-dit-Joli-Village',
      deg: -45,
    },
    {
      name: 'perche4',
      position: { lat: 49.0705533, lng: 2.1717307 },
      label: 'Auberge Ravoux',
      deg: 270,
    },
    {
      name: 'perche5',
      position: { lat: 49.128802, lng: 2.169858 },
      label: 'Nesles-la-Vallée',
      deg: 45,
    },
    {
      name: 'perche6',
      position: { lat: 49.064954, lng: 1.701131 },
      label: 'Vétheuil',
      deg: -230,
    },
    {
      name: 'perche7',
      position: { lat: 49.081065, lng: 1.629327 },
      label: 'La Roche-Guyon',
      deg: 90,
    },
    {
      name: 'perche8',
      position: { lat: 49.0831565, lng: 1.6591581 },
      label: 'Haute-Isle',
      deg: 210,
    },
    {
      name: 'perche9',
      position: { lat: 49.150309, lng: 1.695684 },
      label: 'Ambleville',
      deg: 5,
    },
    {
      name: 'perche10',
      position: { lat: 49.0861551, lng: 1.8953454 },
      label: 'Parc de Théméricourt',
      deg: -40,
    },
    {
      name: 'perche11',
      position: { lat: 49.1199484, lng: 1.7718003 },
      label: 'Site Archéologique de Genainville',
      deg: -215,
    },
    {
      name: 'perche12',
      position: { lat: 49.16303820000001, lng: 1.8438578 },
      label: 'Nucourt',
      deg: -60,
    },
    {
      name: 'perche13',
      position: { lat: 49.0839, lng: 2.005693 },
      label: 'Montgeroult',
      deg: 230,
    },
    {
      name: 'perche14',
      position: { lat: 49.0879557, lng: 1.6768258 },
      label: 'Chérence',
      deg: 90,
    },
    {
      name: 'perche15',
      position: { lat: 49.1512259, lng: 1.8871165000000003 },
      label: 'Le Bellay-en-Vexin',
      deg: 180,
    },
    {
      name: 'perche16',
      position: { lat: 49.086826, lng: 1.894946 },
      label: 'Église de Théméricourt',
      deg: 30,
    },
    {
      name: 'drone1',
      position: { lat: 49.071194600000005, lng: 2.1796915 },
      label: 'Auvers-sur-Oise',
      deg: -5,
    },
    {
      name: 'drone2',
      position: { lat: 49.1017284, lng: 1.9662575 },
      label: 'Us',
      deg: 45,
    },
    {
      name: 'drone3',
      position: { lat: 49.061542, lng: 1.925878 },
      label: 'Longuesse',
      deg: -35,
    },
    {
      name: 'drone4',
      position: { lat: 49.1083737, lng: 1.8414332999999998 },
      label: 'Guiry-en-Vexin',
      deg: 0,
    },
    {
      name: 'drone5',
      position: { lat: 49.1166501, lng: 1.7094251 },
      label: 'Domaine de Villarceaux',
      deg: 225,
    },
    {
      name: 'drone6',
      position: { lat: 49.1593059, lng: 1.7781865 },
      label: 'Magny-en-Vexin',
      deg: 170,
    },
    {
      name: 'drone7',
      position: { lat: 49.2224884, lng: 1.7005096 },
      label: "Vallée de l'Epte",
      deg: 120,
    },
    {
      name: 'drone8',
      position: { lat: 49.128702, lng: 2.049303 },
      label: 'Grisy-les-Plâtres',
      deg: -60,
    },
    {
      name: 'drone9',
      position: { lat: 49.1481064, lng: 1.9907806 },
      label: 'Marines',
      deg: 90,
    },
    {
      name: 'drone10',
      position: { lat: 49.0969578, lng: 2.1905998 },
      label: 'Valmondois',
      deg: 110,
    },
    {
      name: 'drone11',
      position: { lat: 49.0805777, lng: 1.7403622 },
      label: "Buttes d'Arthies",
      deg: 230,
    },
    {
      name: 'drone12',
      position: { lat: 49.1372977, lng: 1.9349131 },
      label: 'Brignancourt',
      deg: -30,
    },
    {
      name: 'drone13',
      position: { lat: 49.1124955, lng: 1.9029571 },
      label: 'Gouzangrez',
      deg: 0,
    },
    {
      name: 'drone14',
      position: { lat: 49.0821689, lng: 1.6578524 },
      label: 'Coteaux de Seine',
      deg: -70,
    },
    {
      name: 'drone15',
      position: { lat: 49.1720802, lng: 2.0018293000000003 },
      label: 'Buttes de Rosne',
      deg: 65,
    },
    {
      name: 'drone16',
      position: { lat: 49.085836, lng: 1.895118 },
      label: 'Themericourt',
      deg: -90,
    },
    {
      name: 'abbaye_de_maubuisson',
      position: { lat: 49.0460957883166, lng: 2.11783639900398 },
      label: 'Abbaye de Maubuisson',
      deg: -125,
    },
    {
      name: 'abbaye_de_royaumont_drone',
      position: { lat: 49.1477339706079, lng: 2.3836247507627 },
      label: 'Abbaye de Royaumont',
      deg: 160,
    },
    {
      name: 'abbaye_de_royaumont_ext',
      position: { lat: 49.1474694535757, lng: 2.38342359849822 },
      label: 'Abbaye de Royaumont et son parc',
      deg: 185,
    },
    {
      name: 'abbaye_de_royaumont_int',
      position: { lat: 49.1476688685386, lng: 2.38206459834565 },
      label: "Cloître de l'Abbaye de Royaumont",
      deg: 90,
    },
    {
      name: 'arnouville-les-gonesse',
      position: { lat: 48.983977028631, lng: 2.4044394493103 },
      label: 'Vallée insolite du Petit Rosne',
      deg: -50,
    },
    {
      name: 'beaumont-sur-oise',
      position: { lat: 49.1439274729954, lng: 2.28649219782641 },
      label: 'Beaumont-sur-Oise',
      deg: 285,
    },
    {
      name: 'buttes_des_chataigniers',
      position: { lat: 48.9618628557403, lng: 2.24942775602589 },
      label: 'Belvédère de la butte des châtaigniers',
      deg: 95,
    },
    {
      name: 'cergy_bas_de_loisirs_drone',
      position: { lat: 49.0307093715281, lng: 2.04824382477122 },
      label: 'Cergy-Pontoise, Île de Loisirs',
      deg: 30,
    },
    {
      name: 'cergy_ot',
      position: { lat: 49.0469804850883, lng: 2.10038176110724 },
      label: "Pontoise, bords d'Oise",
      deg: 180,
    },
    {
      name: 'cergy__tour',
      position: { lat: 49.0460253664998, lng: 2.03353055750621 },
      label: 'Cergy-Pontoise, Axe majeur',
      deg: 155,
    },
    {
      name: 'cergy_tour_pilliers',
      position: { lat: 49.0421730024077, lng: 2.03785896691798 },
      label: "Les 12 colonnes de l'Axe majeur",
      deg: 70,
    },
    {
      name: 'cergy_port',
      position: { lat: 49.0309598721536, lng: 2.06012769429619 },
      label: 'Port Cergy',
      deg: -60,
    },
    {
      name: 'champ_de_ble',
      position: { lat: 49.0912762028036, lng: 2.36527363600899 },
      label: 'Belloy-en-France',
      deg: 70,
    },
    {
      name: 'chateau_et_domaine_de_la_chasse_drone',
      position: { lat: 49.0286083807724, lng: 2.2933350410025 },
      label: 'Domaine du château de la Chasse',
      deg: -120,
    },
    {
      name: 'collegiale_saint_martin_drone',
      position: { lat: 48.984723370515, lng: 2.3196172714233 },
      label: 'Montmorency',
      deg: -70,
    },
    {
      name: 'eaubonne',
      position: { lat: 48.9993960929352, lng: 2.28185395208002 },
      label: 'Eaubonne',
      deg: -80,
    },
    {
      name: 'ecouen',
      position: { lat: 49.0173810468983, lng: 2.37838244328446 },
      label: "Château d'Ecouen",
      deg: -98,
    },
    {
      name: 'ecouene_drone',
      position: { lat: 49.0183344127682, lng: 2.37928890462243 },
      label: 'Ecouen',
      deg: 100,
    },
    {
      name: 'enghien-les-bains_drone',
      position: { lat: 48.9701033884734, lng: 2.29827293028552 },
      label: 'Enghien-les-Bains',
      deg: 195,
    },
    {
      name: 'epiais-les-louvres',
      position: { lat: 49.0318500005387, lng: 2.55706276586594 },
      label: 'Epiais-les-Louvres',
      deg: 1,
    },
    {
      name: 'fort_de_cormeilles_drone',
      position: { lat: 48.9833285812963, lng: 2.19745861815022 },
      label: 'Fort de Cormeilles-en-Parisis',
      deg: 200,
    },
    {
      name: 'franconville',
      position: { lat: 49.1047165135734, lng: 2.33684136428563 },
      label: 'Saint-Martin-du-Tertre',
      deg: -105,
    },
    {
      name: 'gonesse',
      position: { lat: 48.9878216758409, lng: 2.44692620926493 },
      label: 'Gonesse',
      deg: -45,
    },
    {
      name: 'grange_de_vaulerent',
      position: { lat: 49.0538472510973, lng: 2.53321974847033 },
      label: 'Grange de Vaulerand',
      deg: -85,
    },
    {
      name: 'herblay_bac_pietons',
      position: { lat: 48.9866616689285, lng: 2.15750703897901 },
      label: 'Herblay-sur-Seine, bords de Seine',
      deg: -90,
    },
    {
      name: 'herivaux_drone',
      position: { lat: 49.1162017318544, lng: 2.47550745309288 },
      label: "Domaine d'Hérivaux",
      deg: -25,
    },
    {
      name: 'ilde_adam_drone',
      position: { lat: 49.1122566123779, lng: 2.21183220492152 },
      label: "L'Isle-Adam",
      deg: -85,
    },
    {
      name: 'ile_adam',
      position: { lat: 49.114558678082, lng: 2.21200480342362 },
      label: "L'Isle-Adam, la Plage",
      deg: 55,
    },
    {
      name: 'lacs_bleus_drone',
      position: { lat: 49.1182993887457, lng: 2.31884933097178 },
      label: 'Forêt de Carnelle, Lac Bleu',
      deg: -85,
    },
    {
      name: 'louvres',
      position: { lat: 49.0412815420612, lng: 2.50621161973744 },
      label: 'Louvres',
      deg: -4,
    },
    {
      name: 'luzarches',
      position: { lat: 49.1122238244556, lng: 2.42915352889369 },
      label: 'Luzarches',
      deg: 160,
    },
    {
      name: 'meriel',
      position: { lat: 49.0783517222359, lng: 2.22627023122253 },
      label: 'Abbaye Notre-Dame du Val',
      deg: -5,
    },
    {
      name: 'mery-sur-oise',
      position: { lat: 49.0661150457479, lng: 2.18891200808675 },
      label: 'Méry-sur-Oise',
      deg: 0,
    },
    {
      name: 'moulin_de_sannois',
      position: { lat: 48.9685503540441, lng: 2.24132182429156 },
      label: 'Sannois',
      deg: 11,
    },
    {
      name: 'parc_de_grouchy_drone',
      position: { lat: 49.0655551379951, lng: 2.0608227632761 },
      label: 'Osny',
      deg: -55,
    },
    {
      name: 'pavillon_chinois',
      position: { lat: 49.1168949656962, lng: 2.23112672178363 },
      label: "L'Isle-Adam, le Pavillon chinois",
      deg: -30,
    },
    {
      name: 'pontoise_cathedrale',
      position: { lat: 49.0506832159353, lng: 2.09660658525406 },
      label: 'Pontoise, Cathédrale Saint-Maclou',
      deg: 6,
    },
    {
      name: 'poteau_de_la_tour',
      position: { lat: 49.0863894993989, lng: 2.25123006386033 },
      label: "Forêt de L'Isle-Adam",
      deg: -35,
    },
    {
      name: 'roissy',
      position: { lat: 49.003268269997, lng: 2.51930754944089 },
      label: 'Roissy',
      deg: 185,
    },
    {
      name: 'saint-prix',
      position: { lat: 49.0161842048, lng: 2.2666202847572 },
      label: 'Saint-Prix',
      deg: -120,
    },
    {
      name: 'sarcelle_mairie',
      position: { lat: 48.9969500935426, lng: 2.37845830774885 },
      label: 'Sarcelles',
      deg: -70,
    },
    {
      name: 'taverny',
      position: { lat: 49.0301718040449, lng: 2.22748627105119 },
      label: 'Taverny',
      deg: -60,
    },
    {
      name: 'viarmes',
      position: { lat: 49.1257701410671, lng: 2.36930308502478 },
      label: 'Viarmes',
      deg: 40,
    },
    {
      name: 'fort_cormeilles',
      position: { lat: 48.9834666314538, lng: 2.19623210843054 },
      label: 'Fort de Cormeilles-en-Parisis, caserne',
      deg: -135,
    },
    {
      name: 'lac_enghein',
      position: { lat: 48.9682143804321, lng: 2.30387675968972 },
      label: "Jetée du Lac d'Enghien-les-bains",
      deg: -60,
    },
    {
      name: 'parc_grouchy',
      position: { lat: 49.0647391645766, lng: 2.05872876745198 },
      label: 'Osny, Parc du château de Grouchy',
      deg: -45,
    },
    // POI data for label
    // {
    //   name: 'drone1_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Maison-atelier Daubigny',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs2',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Auberge Ravoux',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs3',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Carrière aux coquillages',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: "Château d'Auvers",
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Notre-Dame',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs6',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Maison du Docteur Gachet',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs7',
    //   position: { lat: 0, lng: 0 },
    //   label: "Musée de l'absinthe",
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs8',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Musée Daubigny',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Tombes de Vincent et Théo Van Gogh',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Musée des Tramways à vapeur',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs11',
    //   position: { lat: 0, lng: 0 },
    //   label: "Conseil Départemental du Val d'Oise",
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs12',
    //   position: { lat: 0, lng: 0 },
    //   label: "Château d'Ennery",
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs13',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Aubin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs14',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Paysage du Plateau du Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs15',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Studio Magne',
    //   deg: 0,
    // },
    // {
    //   name: 'drone1_hs16',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Pontoise',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Marais de Boissy-Mongeroult',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs2',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Brignancourt',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs3',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Villette',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Croix Labathe',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Buttes du Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs6',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le Perchay',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs7',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Sagy',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs8',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Pierre',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Etang de Vallière',
    //   deg: 0,
    // },
    // {
    //   name: 'drone2_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Dampont',
    //   deg: 0,
    // },
    // {
    //   name: 'drone3_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Fontaine Saint-Clair',
    //   deg: 0,
    // },
    // {
    //   name: 'drone3_hs6',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Paysage du Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone3_hs7',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Longuesse',
    //   deg: 0,
    // },
    // {
    //   name: 'drone3_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Mare-abreuvoir et lavoir de Rueil',
    //   deg: 0,
    // },
    // {
    //   name: 'drone3_hs12',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Carrière de Vigny-Longuesse',
    //   deg: 0,
    // },
    // {
    //   name: 'drone3_hs13',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Vigny',
    //   deg: 0,
    // },
    // {
    //   name: 'drone3_hs14',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Ferme Mahé',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Sanatorium de la Bucaille',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs2',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château des Tournelles',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs3',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Charmont',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Ferme de Méré',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Commeny',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs7',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Gadancourt',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs8',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Chaussée Jules César',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Dolmen du bois Couturier',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Bois de Morval',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs11',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La "Croisette"',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs12',
    //   position: { lat: 0, lng: 0 },
    //   label: "Musée archéologique départemental du Val d'Oise",
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs13',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Guiry-en-Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs14',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Buttes de Rosne',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs15',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Butte de Marines',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs16',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Maudétour-en-Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs17',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Ferme de Louvières',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs18',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Omerville',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs19',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Manoir de Hazeville',
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs20',
    //   position: { lat: 0, lng: 0 },
    //   label: "Jardin du musée de l'Outil",
    //   deg: 0,
    // },
    // {
    //   name: 'drone4_hs21',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Wy-Dit-Joli-Village',
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs2',
    //   position: { lat: 0, lng: 0 },
    //   label: "Château d'Ambleville",
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs3',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Lavoir du Mauvérand',
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Marais de Frocourt',
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs8',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Domaine de Villarceaux',
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Paysage de la vallée de la Seine',
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Magny-en-Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs12',
    //   position: { lat: 0, lng: 0 },
    //   label: "Vallée de l'Epte",
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs15',
    //   position: { lat: 0, lng: 0 },
    //   label: "Paysage de la vallée de l'Epte",
    //   deg: 0,
    // },
    // {
    //   name: 'drone5_hs16',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Villers',
    //   deg: 0,
    // },
    // {
    //   name: 'drone6_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Notre-Dame',
    //   deg: 0,
    // },
    // {
    //   name: 'drone6_hs11',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Lavoir de la digue',
    //   deg: 0,
    // },
    // {
    //   name: 'drone6_hs19',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Magnitot',
    //   deg: 0,
    // },
    // {
    //   name: 'drone6_hs20',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Gervais et Saint-Protais',
    //   deg: 0,
    // },
    // {
    //   name: 'drone6_hs21',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Saint-Gervais',
    //   deg: 0,
    // },
    // {
    //   name: 'drone7_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: "Jardins du château d'Ambleville",
    //   deg: 0,
    // },
    // {
    //   name: 'drone7_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Clair',
    //   deg: 0,
    // },
    // {
    //   name: 'drone8_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Ferme de la Tour - Colombier',
    //   deg: 0,
    // },
    // {
    //   name: 'drone8_hs7',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Ferme Vanthuyne',
    //   deg: 0,
    // },
    // {
    //   name: 'drone8_hs8',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Jardin de campagne',
    //   deg: 0,
    // },
    // {
    //   name: 'drone8_hs11',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Labbeville',
    //   deg: 0,
    // },
    // {
    //   name: 'drone8_hs14',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Claude',
    //   deg: 0,
    // },
    // {
    //   name: 'drone8_hs15',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Theuville',
    //   deg: 0,
    // },
    // {
    //   name: 'drone8_hs17',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Vallangoujard',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Bréançon',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs2',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le bois du moulin de Noisement',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Chars, patrimoine et nature',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs7',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Georges',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Marines',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Rémi',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs11',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Marines',
    //   deg: 0,
    // },
    // {
    //   name: 'drone9_hs12',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Neuilly-en-Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: "Paysage de la vallée de l'Oise",
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Saint-Cyran',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs6',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Chapelle Saint-Robert',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'Isle-Adam",
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs11',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Croix des Friches',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs12',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Bois de la Tour du Lay',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs13',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Tilleul de l’an I',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs15',
    //   position: { lat: 0, lng: 0 },
    //   label: "Château d'Orgivaux",
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs16',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Cimetière de Valmondois',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs17',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Maison Daumier',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs18',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Maison Duhamel',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs19',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Moulin le Roy',
    //   deg: 0,
    // },
    // {
    //   name: 'drone10_hs20',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Moulin de la Naze',
    //   deg: 0,
    // },
    // {
    //   name: 'drone11_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Lavoir et fontaine Saint-Leu-Saint-Gilles',
    //   deg: 0,
    // },
    // {
    //   name: 'drone11_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Chérence',
    //   deg: 0,
    // },
    // {
    //   name: 'drone11_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de la Bûcherie',
    //   deg: 0,
    // },
    // {
    //   name: 'drone11_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Bois du Chesnay',
    //   deg: 0,
    // },
    // {
    //   name: 'drone12_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Ferme de la distillerie',
    //   deg: 0,
    // },
    // {
    //   name: 'drone12_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Notre-Dame de l’Assomption',
    //   deg: 0,
    // },
    // {
    //   name: 'drone12_hs11',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le Bellay-en-Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone12_hs17',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Manoir seigneurial de Moussy',
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: "Eglise troglodytique de l'Annonciation",
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Réserve Naturelle des Coteaux de Seine',
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs6',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Haute-Isle',
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs7',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de La Roche-Guyon',
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs9',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Potager fruitier du château de La Roche-Guyon',
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs10',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La Roche-Guyon',
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs15',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Notre-Dame',
    //   deg: 0,
    // },
    // {
    //   name: 'drone14_hs16',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Vétheuil',
    //   deg: 0,
    // },
    // {
    //   name: 'drone16_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Maison du Parc naturel régional du Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone16_hs2',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Théméricourt village écrin du Vexin',
    //   deg: 0,
    // },
    // {
    //   name: 'drone15_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: "Colombier d'Haravilliers",
    //   deg: 0,
    // },
    // {
    //   name: 'perche2_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Pierre-et-Saint-Paul',
    //   deg: 0,
    // },
    // {
    //   name: 'perche11_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Site archéologique des Vaux de la Celle',
    //   deg: 0,
    // },
    // {
    //   name: 'perche12_hs1',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Quentin',
    //   deg: 0,
    // },
    // {
    //   name: 'perche12_hs2',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Lavoir de Nucourt',
    //   deg: 0,
    // },
    // {
    //   name: 'perche13_hs4',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Montgeroult',
    //   deg: 0,
    // },
    // {
    //   name: 'perche13_hs5',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Montgeroult',
    //   deg: 0,
    // },
    // {
    //   name: 'arnouville-les-gonesse_eglise_chateau',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le château d’Arnouville et sa chapelle',
    //   deg: 0,
    // },
    // {
    //   name: 'asnieres-sur-oise_abbayederoyaumont',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Royaumont, abbaye royale',
    //   deg: 0,
    // },
    // {
    //   name: 'asnieres-sur-oise_coeurdevillage',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Asnières-sur-Oise cœur du village...',
    //   deg: 0,
    // },
    // {
    //   name: 'asnieres-sur-oise_ensbaillon-marais',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le marais de Baillon',
    //   deg: 0,
    // },
    // {
    //   name: 'baillet-en-france_parc',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Parc du Bois de l’Étang',
    //   deg: 0,
    // },
    // {
    //   name: 'beaumont-sur-oise_chateau',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Beaumont-sur-Oise',
    //   deg: 0,
    // },
    // {
    //   name: 'chaumontel_routepaveedelaménagerie',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Routes anciennes à Hérivaux',
    //   deg: 0,
    // },
    // {
    //   name: 'ecouen_chateau',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le château d’Écouen',
    //   deg: 0,
    // },
    // {
    //   name: 'ecouen_eglisesaint-acceul',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Acceul',
    //   deg: 0,
    // },
    // {
    //   name: 'epinay-champlatreux_chateau',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Champlâtreux',
    //   deg: 0,
    // },
    // {
    //   name: 'gonesse_parc_patte-oie',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Parc de la Patte d’Oie',
    //   deg: 0,
    // },
    // {
    //   name: 'le-mesnil-aubry_eglisedelanativite-de-la-vierge',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise de la Nativité de la Vierge',
    //   deg: 0,
    // },
    // {
    //   name: 'le-plessis-luzarches_boishumide_enslocal',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Bois humide du Plessis-Luzarches',
    //   deg: 0,
    // },
    // {
    //   name: 'louvres_archea',
    //   position: { lat: 0, lng: 0 },
    //   label: 'ARCHÉA',
    //   deg: 0,
    // },
    // {
    //   name: 'louvres_chateau_orville',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Site archéologique du Château d’Orville',
    //   deg: 0,
    // },
    // {
    //   name: 'luzarches_coeurdevillage-halle',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Luzarches, cité au riche passé',
    //   deg: 0,
    // },
    // {
    //   name: 'luzarches_herivaux',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Abbaye Notre-Dame d’Hérivaux',
    //   deg: 0,
    // },
    // {
    //   name: 'maffliers_château_village',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Maffliers : son village et son château',
    //   deg: 0,
    // },
    // {
    //   name: 'mareil-en-france_mairie',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Mairie de Mareil-en-France',
    //   deg: 0,
    // },
    // {
    //   name: 'marly-la-ville_eglise',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Église Saint-Étienne à Marly-la-Ville',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-martin-du-tertre_chateau_franconville',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le château de Franconville-aux-Bois',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-martin-du-tertre_lacbleu',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le Lac Bleu et le Petit Etang',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-martin-du-tertre_pierreturquaise',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La Pierre Turquaise',
    //   deg: 0,
    // },
    // {
    //   name: 'sarcelles_eglisesaint-thomas-apotre',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Église Saint-Thomas-Apôtre à Sarcelles',
    //   deg: 0,
    // },
    // {
    //   name: 'viarmes_village',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Viarmes de tous les siècles',
    //   deg: 0,
    // },
    // {
    //   name: 'villeron_grangedevaulerent',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Grange de Vaulerand',
    //   deg: 0,
    // },
    // {
    //   name: 'arnouville-les-gonesse_eglisenotre-dame-de-la-paix',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Notre-Dame-de-la-Paix à Arnouville',
    //   deg: 0,
    // },
    // {
    //   name: 'arnouville-les-gonesse_fermedescondos',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La ferme des Condos',
    //   deg: 0,
    // },
    // {
    //   name: 'asnieres-sur-oise_abbayederoyaumont-cloître',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Royaumont, chef d’œuvre gothique',
    //   deg: 0,
    // },
    // {
    //   name: 'asnieres-sur-oise_abbayederoyaumont-jardinsremarquables',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Royaumont et ses jardins remarquables',
    //   deg: 0,
    // },
    // {
    //   name: 'epiais-les-louvres_village',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Épiais-les-Louvres',
    //   deg: 0,
    // },
    // {
    //   name: 'garges-les-gonesse_fortdestains',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le fort de Stains',
    //   deg: 0,
    // },
    // {
    //   name: 'luzarches_chateau-motte',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de la Motte',
    //   deg: 0,
    // },
    // {
    //   name: 'luzarches_eglise',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint-Côme et Saint-Damien',
    //   deg: 0,
    // },
    // {
    //   name: 'sarcelles_grandensembledesarcelles',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Grand ensemble de Sarcelles',
    //   deg: 0,
    // },
    // {
    //   name: 'chatenay-en-france_village',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Village de Châtenay-en-France',
    //   deg: 0,
    // },
    // {
    //   name: 'ecouen_domaineecouen',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le domaine du Château',
    //   deg: 0,
    // },
    // {
    //   name: 'ecouen_museedelarenaissance',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le musée national de la Renaissance',
    //   deg: 0,
    // },
    // {
    //   name: 'ecouen_parcoursdespeintres',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Parcours des peintres',
    //   deg: 0,
    // },
    // {
    //   name: 'fosses_vieuxfosses-eglise',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le vieux Fosses',
    //   deg: 0,
    // },
    // {
    //   name: 'gonesse_eglise',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Église Saint-Pierre-Saint-Paul de Gonesse',
    //   deg: 0,
    // },
    // {
    //   name: 'goussainville_vieuxvillage',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le Vieux Pays de Goussainville',
    //   deg: 0,
    // },
    // {
    //   name: 'louvres_tourdest-rieul',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Tour Saint-Rieul',
    //   deg: 0,
    // },
    // {
    //   name: 'roissy-en-france_terminal1roissyaeroport',
    //   position: { lat: 0, lng: 0 },
    //   label: "Terminal 1 de l'aéroport de Roiss",
    //   deg: 0,
    // },
    // {
    //   name: 'roissy-en-france_veritablevillage_idf',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Village de Roissy-en-France',
    //   deg: 0,
    // },
    // {
    //   name: 'roissy-en-france_parcmairie',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le parc de la Mairie',
    //   deg: 0,
    // },
    // {
    //   name: 'sarcelles_village',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Village de Sarcelles',
    //   deg: 0,
    // },
    // {
    //   name: 'andilly_pointdevue',
    //   position: { lat: 0, lng: 0 },
    //   label: "Le plateau d'Andilly",
    //   deg: 0,
    // },
    // {
    //   name: 'argenteuil_basilique_saint-denys',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La basilique Saint-Denys',
    //   deg: 0,
    // },
    // {
    //   name: 'argenteuil_chapellesaintjean_jardinsabbaye',
    //   position: { lat: 0, lng: 0 },
    //   label: "Les jardins de l'abbaye",
    //   deg: 0,
    // },
    // {
    //   name: 'argenteuil_citejardinorgemont',
    //   position: { lat: 0, lng: 0 },
    //   label: "La cité-jardin d'Orgemont",
    //   deg: 0,
    // },
    // {
    //   name: 'chauvry_fermedechauvry',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La ferme de Chauvry',
    //   deg: 0,
    // },
    // {
    //   name: 'cormeilles-en-parisis_fortdecormeilles',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le fort de Cormeilles-en-Parisis',
    //   deg: 0,
    // },
    // {
    //   name: 'enghien-les-bains_lelac_ileauxcygnes',
    //   position: { lat: 0, lng: 0 },
    //   label: "Le lac d'Enghien-les-Bains",
    //   deg: 0,
    // },
    // {
    //   name: 'enghien-les-bains_lesthermes',
    //   position: { lat: 0, lng: 0 },
    //   label: "Les Thermes d'Enghien-les-Bains",
    //   deg: 0,
    // },
    // {
    //   name: 'frette-sur-seine_quai',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Un village en bord de Seine : La Frette',
    //   deg: 0,
    // },
    // {
    //   name: 'herblay_bacdupasseur',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Bienvenue à bord du passeur !',
    //   deg: 0,
    // },
    // {
    //   name: 'herblay_eglisesaint-martin',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'église Saint-Martin d'Herblay-sur-Seine",
    //   deg: 0,
    // },
    // {
    //   name: 'montlignon_foretdemontmorrency_chateaudelachasse',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Forêt de Montmorency et Château de la chasse',
    //   deg: 0,
    // },
    // {
    //   name: 'montmorency_collegiale',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La collégiale Saint-Martin de Montmorency',
    //   deg: 0,
    // },
    // {
    //   name: 'montmorency_maisonrousseau',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le Musée Jean-Jacques Rousseau',
    //   deg: 0,
    // },
    // {
    //   name: 'montmorency_nid_aigle',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La réserve biologique domaniale',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-leu-la-foret_crypteimperiale',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'église Saint-Gilles de Saint-Leu-la-Forêt",
    //   deg: 0,
    // },
    // {
    //   name: 'saint-prix_fontaineauxpelerins',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La fontaine aux Pèlerins',
    //   deg: 0,
    // },
    // {
    //   name: 'sannois_moulindesannois',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le moulin de Sannois',
    //   deg: 0,
    // },
    // {
    //   name: 'taverny_eglise',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'église Notre-Dame de Taverny",
    //   deg: 0,
    // },
    // {
    //   name: 'bessancourt_Églisesaint-gervais-et-saint-protais',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'église Saint-Gervais et Saint-Protais de Bessancourt",
    //   deg: 0,
    // },
    // {
    //   name: 'cormeilles-en-parisis_eglisesaintmartin',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'église Saint-Martin de Cormeilles-en-Parisis",
    //   deg: 0,
    // },
    // {
    //   name: 'cormeilles-en-parisis_fortdecormeilles_cinema',
    //   position: { lat: 0, lng: 0 },
    //   label: "Cormeilles, c'est fort en cinéma !",
    //   deg: 0,
    // },
    // {
    //   name: 'eaubonne_bassindesmoulinets',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le bassin des moulinets',
    //   deg: 0,
    // },
    // {
    //   name: 'frette-sur-seine_eglisesaintnicolas',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'église Saint-Nicolas de La Frette-sur-Seine",
    //   deg: 0,
    // },
    // {
    //   name: 'herblay_carrièresdegaillon',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Les Carrières de Gaillon',
    //   deg: 0,
    // },
    // {
    //   name: 'herblay_rivesdeseine',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Promenades le long des Rives de Seine',
    //   deg: 0,
    // },
    // {
    //   name: 'montigny-les-cormeilles_lasource',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La source',
    //   deg: 0,
    // },
    // {
    //   name: 'sannois_lesvignesdesannois',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Les vignes de Sannois',
    //   deg: 0,
    // },
    // {
    //   name: 'taverny_boisdeboissy',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le Bois de Boissy',
    //   deg: 0,
    // },
    // {
    //   name: 'argenteuil_buttes_orgemont',
    //   position: { lat: 0, lng: 0 },
    //   label: "La butte d'Orgemont",
    //   deg: 0,
    // },
    // {
    //   name: 'argenteuil_buttesdeschataigniers',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La butte des Châtaigniers',
    //   deg: 0,
    // },
    // {
    //   name: 'cormeilles-en-parisis_carrierelambert',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La carrière Lambert',
    //   deg: 0,
    // },
    // {
    //   name: 'cormeilles-en-parisis_parcshlumberger',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le parc Schulmberger de Cormeilles-en-Parisis',
    //   deg: 0,
    // },
    // {
    //   name: 'enghien-les-bains_casino',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'unique casino en Île-de-France",
    //   deg: 0,
    // },
    // {
    //   name: 'enghien-les-bains_pavillondulac',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le Pavillon du Lac',
    //   deg: 0,
    // },
    // {
    //   name: 'enghien-les-bains_villadulac',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La Villa du Lac',
    //   deg: 0,
    // },
    // {
    //   name: 'enghien-les-bains_villegiaturesautourdulac',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Enghien-les-Bains, la villégiature au bord du lac',
    //   deg: 0,
    // },
    // {
    //   name: 'franconville_boiscadetdevaux',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le parc Cadet de Vaux de Franconville',
    //   deg: 0,
    // },
    // {
    //   name: 'franconville_boisdeseboulures',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le bois des Eboulures de Franconville',
    //   deg: 0,
    // },
    // {
    //   name: 'groslay_eglisesaintmartin',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'église Saint-Martin de Groslay",
    //   deg: 0,
    // },
    // {
    //   name: 'montmagny_buttespinson',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La butte Pinson',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-leu-la-foret_gare',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La gare de Saint-Leu-la-Forêt',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-prix_ens',
    //   position: { lat: 0, lng: 0 },
    //   label: "L'Espace Naturel Sensible de Saint-Prix",
    //   deg: 0,
    // },
    // {
    //   name: 'saint-prix_tourplumet',
    //   position: { lat: 0, lng: 0 },
    //   label: 'La tour du Plumet',
    //   deg: 0,
    // },
    // {
    //   name: 'cergy_axemajeur',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Axe Majeur',
    //   deg: 0,
    // },
    // {
    //   name: 'cergy_préfecture_parcfrancoismitterand',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Préfecture et Parc François Mitterand',
    //   deg: 0,
    // },
    // {
    //   name: 'lisle-adam_chateauconti',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château Conti',
    //   deg: 0,
    // },
    // {
    //   name: 'lisle-adam_passerelle_chemindehalage',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Les Passerelles',
    //   deg: 0,
    // },
    // {
    //   name: 'lisle-adam_pavillonchinois',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Pavillon Chinois',
    //   deg: 0,
    // },
    // {
    //   name: 'lisle-adam_plage',
    //   position: { lat: 0, lng: 0 },
    //   label: "Plage de L'Isle Adam",
    //   deg: 0,
    // },
    // {
    //   name: 'lisle-adam_pontducabouillet',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Pont du Cabouillet',
    //   deg: 0,
    // },
    // {
    //   name: 'meriel_maraisdestors',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Marais de Stors',
    //   deg: 0,
    // },
    // {
    //   name: 'mery-sur-oise_chateau',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Château de Méry',
    //   deg: 0,
    // },
    // {
    //   name: 'nerville-la-foret_poteaudelatour',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Poteau de la Tour',
    //   deg: 0,
    // },
    // {
    //   name: 'neuville-sur-oise_iledeloisirs',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Ile de loisirs',
    //   deg: 0,
    // },
    // {
    //   name: 'nointel_château',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Le château de Nointel',
    //   deg: 0,
    // },
    // {
    //   name: 'osny_chateau_parcdegrouchy',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Parc et château de Grouchy',
    //   deg: 0,
    // },
    // {
    //   name: 'pontoise_cathedralesaint-maclou',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Cathédrale Saint-Maclou',
    //   deg: 0,
    // },
    // {
    //   name: 'pontoise_museecamillepissarro',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Musée Camille Pissarro',
    //   deg: 0,
    // },
    // {
    //   name: 'presles_eglise-village-bilbiotheque',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Presles',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-ouen-laumone_abbayedemaubuisson',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Abbaye de Maubuisson',
    //   deg: 0,
    // },
    // {
    //   name: 'cergy_eglisesaintchristophe-cergyvillage',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Eglise Saint Christophe',
    //   deg: 0,
    // },

    // {
    //   name: 'cergy_horlogegarecergystchristophe',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Horloge',
    //   deg: 0,
    // },
    // {
    //   name: 'cergy_passerelleaxemajeur',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Passerelle de l’Axe majeur',
    //   deg: 0,
    // },

    // {
    //   name: 'cergy_portcergymarina',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Port Cergy et sa marina',
    //   deg: 0,
    // },
    // {
    //   name: 'jouy-le-moutier_foret_hautil',
    //   position: { lat: 0, lng: 0 },
    //   label: "Forêt d'Hautil",
    //   deg: 0,
    // },

    // {
    //   name: 'meriel_abbayenotredameduval',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Abbaye Notre-Dame-du-Val',
    //   deg: 0,
    // },
    // {
    //   name: 'neuville-sur-oise_château_pavillonamour',
    //   position: { lat: 0, lng: 0 },
    //   label: "Château et Pavillon d'Amour",
    //   deg: 0,
    // },

    // {
    //   name: 'pontoise_fortifications',
    //   position: { lat: 0, lng: 0 },
    //   label: 'Parc, casemates et remparts',
    //   deg: 0,
    // },
    // {
    //   name: 'saint-ouen-laumone_bords_oise_ecluses',
    //   position: { lat: 0, lng: 0 },
    //   label: "Chemin de halage et berges de l'Oise",
    //   deg: 0,
    // },
  ];

  constructor() {}
}
